<div class="page-wrapper pre-auth-page py-3">
  <div class="container-fluid flex-grow-1" >
    <div class="d-flex justify-content-end">
      <app-language-selector></app-language-selector>
    </div>
    <div class="row position-row g-0 align-items-stretch">
      <div class="col-lg-4 col-12 p-0">
        <div class="header d-flex flex-column justify-content-center align-items-center gap-3 position-relative">
          <app-logo role="h1" [logoPath]="'logo.svg'"></app-logo>
          <app-powered-by></app-powered-by>
        </div>
        <router-outlet></router-outlet>
      </div>
      <div class="col-lg-8 d-none d-lg-block img-wrap">
        <img class="auth-image" src="/assets/image/auth_image.png">
      </div>
    </div>
  </div>
</div>